<app-header></app-header>

<div class="container mt-5 mb-5">
  <div class="container image-container text-center">
    <img src="/assets/security.png" alt="" height="250" />
    <div class="row">
      <div class="d-flex justify-content-center">
        <div class="col-12 col-lg-6">
          <div class="text-center">
            <h1 style="color: #00943a"><strong>Verify your email</strong></h1>
            <p style="font-size: 16px; margin-bottom: 1rem;">
              To keep your account secured and protected a verification link has been sent to your email.
            </p>  
            <button
            class="mt-3 mb-3"
            mat-raised-button
            color="primary"
            class="text-white"
            [style.width.%]="100"
            type="button"
            (click)="navigateLogin()"
          >
            Go back to login
          </button>
        </div>
        </div>
      </div>
    </div>

  </div>
</div>



<app-footer></app-footer>
